const DATABASE = "thera-device";
const VERSION = 6;

export const ACTIVITY_DRAFT_STORE = "activity-drafts";
export const ROUTE_DRAFT_STORE = "route-submission-drafts";
export const NAVIGATION_SESSION_STORE = "navigation-sessions";
export const ACTIVITY_HISTORY_STORE = "activity-history";
export const WEATHER_CACHE_STORE = "weather-cache";
export const ROUTE_CACHE_STORE = "published-route-cache";
export const APPROACH_ROUTE_CACHE_STORE = "approach-route-cache";

export function openDeviceDatabase(): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DATABASE, VERSION);
    request.onupgradeneeded = () => {
      const database = request.result;
      if (!database.objectStoreNames.contains(ACTIVITY_DRAFT_STORE)) {
        database.createObjectStore(ACTIVITY_DRAFT_STORE);
      }
      if (!database.objectStoreNames.contains(ROUTE_DRAFT_STORE)) {
        database.createObjectStore(ROUTE_DRAFT_STORE, { keyPath: "storageKey" });
      }
      if (!database.objectStoreNames.contains(NAVIGATION_SESSION_STORE)) {
        database.createObjectStore(NAVIGATION_SESSION_STORE, { keyPath: "storageKey" });
      }
      if (!database.objectStoreNames.contains(ACTIVITY_HISTORY_STORE)) {
        const history = database.createObjectStore(ACTIVITY_HISTORY_STORE, { keyPath: "id" });
        history.createIndex("ownerId", "ownerId", { unique: false });
      }
      if (!database.objectStoreNames.contains(WEATHER_CACHE_STORE)) {
        database.createObjectStore(WEATHER_CACHE_STORE, { keyPath: "routeId" });
      }
      if (!database.objectStoreNames.contains(ROUTE_CACHE_STORE)) {
        database.createObjectStore(ROUTE_CACHE_STORE, { keyPath: "id" });
      }
      if (!database.objectStoreNames.contains(APPROACH_ROUTE_CACHE_STORE)) {
        database.createObjectStore(APPROACH_ROUTE_CACHE_STORE, { keyPath: "cacheKey" });
      }
    };
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
}
